import React, { Component } from 'react';
import { Form, Button, Col, Modal, message } from "antd";
import InputForm from "../components/InputForm";
import { validateSenha } from "../utils/Validator";
import axios from "axios";
import { getUsuario } from "../utils/LoginManager";

const ItemForm = Form.Item;

export default class extends Component {
    state = {}

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        this.setState({
            [id]: value
        });
    };

    componentDidMount() {
        this.buscaSenha();
    }

    buscaSenha = (value) => {
        const usuario = getUsuario();
        this.setState({
            carregando: false,
            usuario: usuario.usu_idf,
        });
    }


    onGravarClick = () => {
        const { usuario, senha, senhaAtual, novaSenha1, novaSenha2 } = this.state;

        if ((!senhaAtual) || (senhaAtual === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Informe a Senha Atual' });
            return;
        }
        if ((!novaSenha1) || (novaSenha1 === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Informe a Nova Senha' });
            return;
        }
        if ((!novaSenha1) || (novaSenha2 === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Informe a Nova Senha' });
            return;
        }

        // console.log('onGravarClick: ', senhaAtual);
        // console.log('onGravarClick: ', novaSenha1);
        // console.log('onGravarClick: ', novaSenha2);
        // console.log('onGravarClick: ', senha);

        // if (senhaAtual !== senha) {
        //     Modal.warning({ title: 'Aviso!', content: 'Senha atual não confere.', });
        //     return;
        // } else if (novaSenha1 !== novaSenha2) {
        //     Modal.warning({ title: 'Aviso!', content: 'As novas senhas não conferem.', });
        //     return;
        // }

        if (novaSenha1 !== novaSenha2) {
            Modal.warning({ title: 'Aviso!', content: 'As novas senhas não conferem', });
            return;
        }

        this.setState({ salvando: true })

        axios.put(`/usuarios/updateSenha/${usuario}`, {
            senhaAtual: senhaAtual,
            senhaNova: novaSenha1,
        })
            .then(response => {
                this.setState({
                    salvando: false,
                    senhaAtual: "",
                    novaSenha1: "",
                    novaSenha2: "",
                });
                message.success('Senha Alterada com Sucesso.');
            })
            .catch(error => {
                let mensagem = '';
                if (error.response.status === 500) {
                    mensagem = error.response.data;
                }
                console.error(error.response);
                this.setState({
                    salvando: false
                })
                Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + mensagem, okText: 'OK', })
            })
    };


    render() {
        const { senhaAtual, novaSenha1, novaSenha2, salvando } = this.state;
        return (
            <div className="contentRoutesContainer">
                <Form onSubmit={this.onLogin}>
                    <span className="tituloPage">Alterar Senha do Usuário</span>
                    <div className="divider-form" />
                    <br />

                    <Col xs={24} sm={5} className="camposEspacoDireita" style={{ marginTop: 5 }}>
                        <span>Senha Atual</span>
                        <InputForm
                            type="password"
                            id="senhaAtual"
                            ref="senhaAtual"
                            title="Digite a Senha"
                            placeholder="Digita a Senha Atual"
                            size="large"
                            maxLength={10}
                            validator={validateSenha}
                            value={senhaAtual}
                            onChange={this.onChange}
                            errorMessage="Senha Inválida"
                        />
                    </Col>

                    <Col xs={24} sm={5} className="camposEspacoDireita" style={{ marginTop: 5 }}>
                        <span>Nova Senha</span>
                        <InputForm
                            type="password"
                            id="novaSenha1"
                            ref="novaSenha1"
                            title="Digite a Senha"
                            placeholder="Digita a Nova Senha"
                            size="large"
                            maxLength={10}
                            validator={validateSenha}
                            value={novaSenha1}
                            onChange={this.onChange}
                            errorMessage="Senha Inválida"
                        />
                    </Col>

                    <Col xs={24} sm={5} style={{ marginTop: 5 }}>
                        <span>Confirme a Nova Senha</span>
                        <InputForm
                            type="password"
                            id="novaSenha2"
                            ref="novaSenha2"
                            title="Digite a Senha"
                            placeholder="Confirme a Nova Senha"
                            size="large"
                            maxLength={10}
                            validator={validateSenha}
                            value={novaSenha2}
                            onChange={this.onChange}
                            errorMessage="Senha Inválida"
                        />
                    </Col>

                    <Col xs={24} sm={4} className="avaliacoesPageFiltro-camposBusca" style={{ marginTop: 20 }}>
                        <ItemForm>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn-salvar"
                                size="large"
                                loading={salvando}
                                onClick={this.onGravarClick}
                            >
                                Salvar Senha
                            </Button>
                        </ItemForm>
                    </Col>

                </Form>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/AlterarSenhaPage.js